// ── Shared visits store — rep portal visits propagate to admin control panel ──
// Uses localStorage + pub/sub so both portals see the same visit data in real-time

const LS_KEY = "mpcare_shared_visits";

function load() {
  try { const raw = localStorage.getItem(LS_KEY); if (raw) return JSON.parse(raw); } catch (e) {}
  return [];
}

function save(visits) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(visits)); } catch (e) {}
}

const SHARED_VISITS = {
  _visits: load(),
  _subs: [],

  getAll() { return this._visits; },

  /** Get visits for a specific rep */
  getByRep(repName) {
    return this._visits.filter(v => v.rep === repName);
  },

  /** Get visits for a specific customer company */
  getByCustomer(company) {
    return this._visits.filter(v => v.company === company);
  },

  /** Add a new visit (called by rep portal when logging a visit). Accepts an
   *  optional `visit.id` so the caller can generate a stable client_id ONCE
   *  and use the same value for the Supabase insert (shop_visits.client_id,
   *  Phase B) and the localStorage mirror. Backward-compatible: if no id is
   *  passed, the legacy auto-generator fires, matching the pre-Phase-B
   *  behavior exactly. Never mutates or removes existing entries. */
  add(visit) {
    // visit: { id?, rep, company, date, note, type, duration, createdAt? }
    const entry = {
      id: visit.id || (Date.now() + "-" + Math.random().toString(36).slice(2, 6)),
      rep: visit.rep || "Marcus T.",
      company: visit.company,
      date: visit.date,
      note: visit.note || "",
      type: visit.type || "shop_visit",
      duration: visit.duration || 30,
      createdAt: visit.createdAt || new Date().toISOString()
    };
    this._visits = [entry, ...this._visits];
    save(this._visits);
    this._notify();
    return entry;
  },

  /** Subscribe to changes */
  subscribe(fn) {
    this._subs.push(fn);
    return () => { this._subs = this._subs.filter(f => f !== fn); };
  },

  _notify() {
    const visits = this._visits;
    this._subs.forEach(fn => { try { fn(visits); } catch (e) {} });
  }
};

export default SHARED_VISITS;
